import { render } from "./AddVirementPage.vue?vue&type=template&id=a8af2838&ts=true"
import script from "./AddVirementPage.vue?vue&type=script&lang=ts"
export * from "./AddVirementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__